import * as mutations from './mutations'
import * as actions from './actions'

export default {
  namespaced: true,
  state () {
    return {
      showMenus: false,
      loading: true,
      height: undefined,
      cancelUrl: undefined
    }
  },
  mutations,
  actions
}
